export default "__VITE_ASSET__B6McQk_T__"